/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Button from "../../../component/button";
// API helper and constant
import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";

// Loader
import Loader from "../../../component/loader";
import Paper from "@mui/material/Paper";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";

import pdfIcon from "../../../asset/images/pdf.png";
import Breadcrumb from "../../../component/breadcrumb";

// Upload document dialog
import UploadDocumentsDialog from "./uploadDocumentsDialog";
import EditContract from "./editContract";
import Tooltip from "@mui/material/Tooltip";
import ViewRequestorsDialog from "./viewRequestorDialog";
import { withTranslation } from "react-i18next";

//dialogs
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import IconButton from "@mui/material/IconButton";
import {
  EditIcon,
  AddDocumentsIcon,
  PublishIcon,
  AcceptIcon,
  DeleteIcon,
  ViewIcon,
  RefreshIcon,
} from "../../../component/icons/icons";
import { Divider, DialogContentText } from "@mui/material";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
import { withNavigation } from "../../../helper/withNavigation.js";
class ViewContract extends Component {
  state = {
    contractId: "",
    loading: false,
    contractData: {},
    tab: 0,
    contractType: "",
    selectedContractReceiver: {},
    open: false,
    bread: [],
    openEditContract: false,
    selectedContractToEdit: {},
    salesChannelProvidersList: [],
    solutionProvidersList: [],
    serviceProvidersList: [],
    requestorList: [],
    showRequestorsDialog: false,
    requestorListPartyId: "",
    openDeleteDialog: false,
    selectedDocToDelete: "",
    openDeleteContractDialog: false,
    copyContract: false,
  };
  componentDidMount() {
    this.props.setCompDidMount();
    let contractId = this.props.router.params.contractId;
    this.setState(
      {
        contractId: contractId,
      },
      () => {
        this.getContractData();
      },
    );
  }

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  formatDate() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  // get contract data
  getContractData = () => {
    this.setState({
      loading: true,
    });
    if (this.props.router.params.provider) {
      BusApiCall(
        "GET",
        `${constants.busV4Url}/providers/${this.props.router.params.provider}/contracts/${this.state.contractId}`,
      )
        .then((res) => {
          let data = res.data;
          let contractType = "view";
          let bread = [
            {
              title: localStorage.getItem("selectedAvailableSolutionProvider"),
              url: `/availableOfferings`,
            },
            {
              title: "Contracts",
              url: `/${this.props.router.params.provider}/contracts`,
            },
            {
              title: `${data.title}`,
              url: `${this.props.router.location.pathname}`,
            },
          ];
          data.parties.to.name = "All";
          this.setState({
            bread,
            contractType: contractType,
            contractData: data,
            loading: false,
          });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
          });
        });
    } else {
      let id = "";
      if (this.props.router.params.id) {
        id = this.props.router.params.id;
      }
      let contractType = "";
      Promise.all([
        BusApiCall("GET", `${constants.busV4Url}/sales-channel-providers`),
        BusApiCall("GET", `${constants.busV4Url}/solution-providers`),
        BusApiCall("GET", `${constants.busV4Url}/service-providers`),
        BusApiCall(
          "GET",
          `${constants.busV4Url}/providers/${id ? id : this.props.tenantId}/contracts/${this.state.contractId}`,
        ),
      ])
        .then((res) => {
          let salesChannelProvidersList = res[0].data;
          let solutionProvidersList = res[1].data;
          let serviceProvidersList = res[2].data;
          let data = res[3].data;

          if (data.parties.from.id === this.props.tenantId) {
            contractType = "outbound";
            if (data.parties.to.id) {
              if (data.parties.to.type === "SALES_CHNL_PROVIDER") {
                for (var i = 0; i < salesChannelProvidersList.length; i++) {
                  if (salesChannelProvidersList[i].id === data.parties.to.id) {
                    data.parties.to.name = salesChannelProvidersList[i].name;
                  }
                }
              } else if (data.parties.to.type === "SOLUTION_PROVIDER") {
                for (var i = 0; i < solutionProvidersList.length; i++) {
                  if (solutionProvidersList[i].id === data.parties.to.id) {
                    data.parties.to.name = solutionProvidersList[i].name;
                  }
                }
              } else if (data.parties.to.type === "SERVICE_PROVIDER") {
                for (var i = 0; i < serviceProvidersList.length; i++) {
                  if (serviceProvidersList[i].id === data.parties.to.id) {
                    data.parties.to.name = serviceProvidersList[i].name;
                  }
                }
              }
              // if (data.parties.to.type === 'SALES_CHNL_PROVIDER') {
              //     for (var i = 0; i < salesChannelProvidersList.length; i++) {
              //         if (salesChannelProvidersList[i].id === data.parties.to.id) {
              //             data.parties.to.name = salesChannelProvidersList[i].name
              //         }
              //     }
              // } else if (data.parties.to.id === this.props.tenantId) {
              //     contractType = 'inbound';
              //     if (data.parties.from.type === 'SALES_CHNL_PROVIDER') {
              //         for (var i = 0; i < salesChannelProvidersList.length; i++) {
              //             if (salesChannelProvidersList[i].id === data.parties.from.id) {
              //                 data.parties.from.name = salesChannelProvidersList[i].name
              //             }
              //         }
              //     } else if (data.parties.from.type === 'SOLUTION_PROVIDER') {
              //         console.log('==here is solution provider==')
              //         for (var i = 0; i < solutionProvidersList.length; i++) {
              //             if (solutionProvidersList[i].id === data.parties.from.id) {
              //                 data.parties.from.name = solutionProvidersList[i].name
              //             }
              //         }
              //     }
              // } else if (data.parties.to.type === 'SERVICE_PROVIDER') {
              //     for (var i = 0; i < serviceProvidersList.length; i++) {
              //         if (serviceProvidersList[i].id === data.parties.to.id) {
              //             data.parties.to.name = serviceProvidersList[i].name
              //         }
              //     }
              // }
            } else {
              data.parties.to.name = "All";
            }
            if (data.expiryDate) {
              if (data.expiryDate.split(" ")[0] < this.formatDate()) {
                data.status = "Expired";
              }
            }
          } else if (data.parties.to.id === this.props.tenantId) {
            contractType = "inbound";
            // if (data.parties.from.type === 'SALES_CHNL_PROVIDER') {
            //     for (var i = 0; i < salesChannelProvidersList.length; i++) {
            //         if (salesChannelProvidersList[i].id === data.parties.from.id) {
            //             data.parties.from.name = salesChannelProvidersList[i].name
            //         }
            //     }
            // } else if (data.parties.from.type === 'SOLUTION_PROVIDER') {
            //     for (var i = 0; i < solutionProvidersList.length; i++) {
            //         if (solutionProvidersList[i].id === data.parties.from.id) {
            //             data.parties.from.name = solutionProvidersList[i].name
            //         }
            //     }
            // } else if (data.parties.from.type === 'SERVICE_PROVIDER') {
            //     for (var i = 0; i < serviceProvidersList.length; i++) {
            //         if (serviceProvidersList[i].id === data.parties.from.id) {
            //             data.parties.from.name = serviceProvidersList[i].name
            //         }
            //     }
            // }
          }
          let bread = [
            { title: this.props.t("MY_CONTRACTS"), url: "/contracts" },
            {
              title: `${data.title}`,
              url: id
                ? `/contract/${id}/${this.props.router.params.contractId}`
                : `/contract/${this.props.router.params.contractId}`,
            },
          ];
          this.setState({
            salesChannelProvidersList: salesChannelProvidersList,
            solutionProvidersList: solutionProvidersList,
            serviceProvidersList: serviceProvidersList,

            bread,
            contractType: contractType,
            contractData: data,
            selectedContractReceiver: data.parties.to,
            loading: false,
          });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false });
        });
    }
  };

  changeProviderType = (type) => {
    if (type === "SALES_CHNL_PROVIDER") {
      return "Sales Channel Provider";
    } else if (type === "SOLUTION_PROVIDER") {
      return "Solution Provider";
    } else if (type === "SERVICE_PROVIDER") {
      return "Service Provider";
    }
  };

  addDocument = () => {
    this.setState({
      open: true,
    });
  };

  // Covert base64 to array buffer
  base64ToArrayBuffer = (base64) => {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  };

  downloadPdf = (id, title) => {
    let providerId =
      this.state.contractData.parties.from.id === this.props.tenantId
        ? this.props.tenantId
        : this.state.contractData.parties.from.id;
    this.setState({
      loading: true,
    });
    BusApiCall(
      "GET",
      `${constants.busV4Url}/providers/${providerId}/contracts/${this.state.contractId}/items/${id}/document`,
    )
      .then((res) => {
        // Convert pdf to array buffer
        var arrrayBuffer = this.base64ToArrayBuffer(
          res.data.data.replace("data:application/pdf;base64,", ""),
        );
        // Create pdf blob
        var blob = new Blob([arrrayBuffer], { type: "application/pdf" }, title);
        // Create URL object and download
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        // link.download = title + '.pdf';
        link.download = title;
        link.dispatchEvent(new MouseEvent("click"));
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  viewPdf = (id) => {
    this.setState({
      loading: true,
    });
    BusApiCall(
      "GET",
      `${constants.busV4Url}/providers/${this.props.tenantId}/contracts/${this.state.contractId}/items/${id}/document`,
    )
      .then((res) => {
        let byteCharacters = atob(
          res.data.data.replace("data:application/pdf;base64,", ""),
        );
        let byteArrays = [];
        let sliceSize = 512;
        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          let slice = byteCharacters.slice(offset, offset + sliceSize);

          let byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          let byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        let file = new Blob(byteArrays, { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  closeDocumentDialog = (message, type) => {
    if (message) {
      this.props.setErrorMessage(message, type);
      this.setState({
        open: false,
      });
      if (type) {
        this.getContractData();
      }
    } else {
      this.setState({
        open: false,
      });
    }
  };

  acceptContract = () => {
    this.setState({ loading: true });
    let data = { ...this.state.contractData };
    data.status = "In Progress";
    if (!data.description) {
      data.description = "";
    }
    if (!data.expiryDate) {
      data.expiryDate = "";
    }
    delete data.id;
    delete data.items;
    delete data.parties.from.name;
    BusApiCall(
      "PATCH",
      `${constants.busV4Url}/providers/${this.props.router.params.id}/contracts/${this.state.contractId}`,
      data,
    )
      .then((res) => {
        this.props.setErrorMessage(
          this.props.t(
            "CONTRACT_ACCEPTED_YOU_SHOULD_EXPECT_AN_E-MAIL_FOR_ELECTRONIC_SIGNATURE",
          ),
          true,
        );
        this.getContractData();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  publishContract = () => {
    this.setState({ loading: true });
    let data = { ...this.state.contractData };
    data.status = "Published";
    if (!data.description) {
      data.description = "";
    }
    if (!data.expiryDate) {
      data.expiryDate = "";
    }
    data.parties.to.id = data.parties.to.id ? data.parties.to.id : "";
    delete data.id;
    delete data.items;
    delete data.parties.from.name;
    delete data.parties.to.name;
    BusApiCall(
      "PATCH",
      `${constants.busV4Url}/providers/${this.props.tenantId}/contracts/${this.state.contractId}`,
      data,
    )
      .then((res) => {
        this.props.setErrorMessage(
          this.props.t("CONTRACT_PUBLISHED_SUCCESSFULLY"),
          true,
        );
        this.getContractData();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  requestContract = () => {
    this.setState({
      loading: true,
    });
    let providerType = "";
    if (this.props.providerType === "SALES_CHNL_PROVIDER") {
      providerType = "/sales-channel-providers";
    } else if (this.props.providerType === "SOLUTION_PROVIDER") {
      providerType = "/solution-providers";
    } else if (this.props.providerType === "SERVICE_PROVIDER") {
      providerType = "/service-providers";
    }
    let requestData = {};
    BusApiCall("GET", `${constants.busV4Url}${providerType}`)
      .then((res) => {
        let providersList = res.data;
        let provider = providersList.find(
          (obj) => this.props.tenantId === obj.id,
        );
        requestData.requestorName = provider.contacts[0].name;
        requestData.requestorEmail = provider.contacts[0].email;
        requestData.requestorPhone = provider.contacts[0].phone;
        requestData.requestorOrg = provider.name;
        requestData.contractName = this.state.contractData.title;
        requestData.senderPartyId = this.props.tenantId;

        let recipientType = "";
        if (
          this.state.contractData.parties.from.type === "SALES_CHNL_PROVIDER"
        ) {
          recipientType = "/sales-channel-providers";
        } else if (
          this.state.contractData.parties.from.type === "SOLUTION_PROVIDER"
        ) {
          recipientType = "/solution-providers";
        } else if (
          this.state.contractData.parties.from.type === "SERVICE_PROVIDER"
        ) {
          recipientType = "/service-providers";
        }
        BusApiCall("GET", `${constants.busV4Url}${recipientType}`)
          .then((response) => {
            let recipientsList = response.data;
            let recipient = recipientsList.find(
              (obj) => this.state.contractData.parties.from.id === obj.id,
            );
            if (!recipient) {
              recipient = recipientsList.find(
                (obj) =>
                  this.state.contractData.parties.from.id === obj.externalId,
              );
            }
            requestData.recipientName = recipient.contacts[0].name;
            requestData.receiverPartyId = recipient.id;
            BusApiCall(
              "POST",
              `${constants.busV4Url}/providers/${requestData.receiverPartyId}/contracts/${this.state.contractData.id}/requests`,
              requestData,
            )
              .then((mailResponse) => {
                this.props.setErrorMessage(
                  this.props.t("PROVIDER_NOTIFIED_OF_CONTRACT_REQUEST"),
                  true,
                );
                this.setState({
                  loading: false,
                });
              })
              .catch((err) => {
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                ) {
                  this.props.setErrorMessage(err.response.data.message, false);
                } else {
                  this.props.setErrorMessage(
                    this.props.t("DEFAULT_ERROR_MESSAGE"),
                    false,
                  );
                }
                this.setState({
                  loading: false,
                });
              });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  editContract = () => {
    let selectedData = {};
    selectedData.title = this.state.contractData.title;
    selectedData.effectiveDate =
      this.state.contractData.effectiveDate.split(" ")[0];
    selectedData.expiryDate = this.state.contractData.expiryDate
      ? this.state.contractData.expiryDate.split(" ")[0]
      : "";
    selectedData.description = this.state.contractData.description
      ? this.state.contractData.description
      : "";
    selectedData.status = this.state.contractData.status;
    selectedData.partyFromId = this.state.contractData.parties.from.id;
    selectedData.partyFromType = this.state.contractData.parties.from.type;
    selectedData.partyToId = this.state.contractData.parties.to.id
      ? this.state.contractData.parties.to.id
      : "";
    selectedData.partyToType = this.state.contractData.parties.to.type;
    this.setState({
      selectedContractToEdit: selectedData,
      openEditContract: true,
    });
  };

  closeUpdateContract = (obj) => {
    if (obj) {
      let data = {};
      data.title = obj.title;
      data.effectiveDate = obj.effectiveDate + " 00:00:00";
      data.expiryDate = obj.expiryDate ? obj.expiryDate + " 00:00:00" : "";
      data.description = obj.description;
      data.status = obj.status;
      data.parties = {
        from: {
          id: obj.partyFromId,
          type: obj.partyFromType,
        },
        to: {
          type: obj.partyToType,
          id: obj.partyToId,
        },
      };

      this.setState({ loading: true });
      BusApiCall(
        "PATCH",
        `${constants.busV4Url}/providers/${this.props.tenantId}/contracts/${this.state.contractData.id}`,
        data,
      )
        .then((res) => {
          this.props.setErrorMessage(
            this.props.t("Contract Updated Successfully"),
            true,
          );
          this.setState({
            selectedContractToEdit: {},
            openEditContract: false,
          });
          this.getContractData();
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
            selectedContractToEdit: {},
            openEditContract: false,
          });
        });
    } else {
      this.setState({
        selectedContractToEdit: {},
        openEditContract: false,
      });
    }
  };

  deleteDoc = (id) => {
    this.setState({
      selectedDocToDelete: id,
      openDeleteDialog: true,
    });
  };

  viewRequestors = () => {
    this.setState({
      requestorListPartyId:
        this.state.contractData.parties.from.id === this.props.tenantId
          ? this.props.tenantId
          : this.state.contractData.parties.from.id,
      showRequestorsDialog: true,
      copyContract:
        this.state.contractData.parties.from.id === this.props.tenantId
          ? true
          : false,
    });
  };

  closeRequestorDialog = (id) => {
    this.setState({
      showRequestorsDialog: false,
    });
    if (id) {
      this.props.router.navigate("/contract/" + id);
      let contractId = id;
      this.setState(
        {
          contractId: contractId,
        },
        () => {
          this.getContractData();
        },
      );
    }
  };

  closeDeleteConfirmation = (val) => {
    this.setState({
      openDeleteDialog: false,
    });
    if (val) {
      this.setState({
        loading: true,
      });
      BusApiCall(
        "DELETE",
        `${constants.busV4Url}/providers/${this.props.tenantId}/contracts/${this.state.contractData.id}/items/${this.state.selectedDocToDelete}`,
      )
        .then((res) => {
          this.props.setErrorMessage(
            this.props.t("DOCUMENT_DELETED_SUCCESSFULLY"),
            true,
          );
          this.setState({ selectedDocToDelete: "" });
          this.getContractData();
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false, selectedDocToDelete: "" });
        });
    }
  };

  deleteContract = () => {
    this.setState({ openDeleteContractDialog: true });
  };

  closeDeleteContractConfirmation = (val) => {
    this.setState({ openDeleteContractDialog: false });
    if (val) {
      let data = {};
      data.title = this.state.contractData.title;
      data.effectiveDate = this.state.contractData.effectiveDate;
      data.expiryDate = this.state.contractData.expiryDate
        ? this.state.contractData.expiryDate
        : "";
      data.description = this.state.contractData.description
        ? this.state.contractData.description
        : "";
      data.status = "Deleted";
      data.parties = {
        from: {
          id: this.state.contractData.parties.from.id,
          type: this.state.contractData.parties.from.type,
        },
        to: {
          type: this.state.contractData.parties.to.type,
          id: this.state.contractData.parties.to.id
            ? this.state.contractData.parties.to.id
            : "",
        },
      };

      this.setState({ loading: true });
      BusApiCall(
        "PATCH",
        `${constants.busV4Url}/providers/${this.props.tenantId}/contracts/${this.state.contractData.id}`,
        data,
      )
        .then((res) => {
          this.props.setErrorMessage(
            this.props.t("CONTRACT_DELETED_SUCCESSFULLY"),
            true,
          );
          this.getContractData();
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false });
        });
    }
  };

  handleChange = () => {};
  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              <Grid
                item
                style={{ textAlign: "right" }}
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                {this.props.userPerms.includes("CUMULATOR-CONTRACT_UPDATE") &&
                  this.state.contractType === "outbound" &&
                  (this.state.contractData.status === "Published" ||
                    this.state.contractData.status === "Draft") && (
                    <>
                      <Tooltip title={t("DELETE")}>
                        <IconButton onClick={() => this.deleteContract()}>
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>{" "}
                      &nbsp;
                    </>
                  )}
                {this.props.userPerms.includes("CUMULATOR-CONTRACT_UPDATE") &&
                  this.state.contractType === "outbound" &&
                  this.state.contractData.status === "Draft" &&
                  this.state.contractData.items.length > 0 && (
                    <>
                      <Tooltip title={t("PUBLISH")}>
                        <IconButton onClick={() => this.publishContract()}>
                          <PublishIcon />
                        </IconButton>
                      </Tooltip>{" "}
                      &nbsp;
                    </>
                  )}
                {this.props.userPerms.includes("CUMULATOR-CONTRACT_UPDATE") &&
                  this.state.contractType === "inbound" &&
                  this.state.contractData.status === "Published" && (
                    <>
                      <Tooltip title={t("ACCEPT")}>
                        <IconButton onClick={() => this.acceptContract()}>
                          <AcceptIcon />
                        </IconButton>
                      </Tooltip>{" "}
                      &nbsp;
                    </>
                  )}
                {this.state.contractType === "view" && (
                  <>
                    <Tooltip title={t("REQUEST")}>
                      <IconButton onClick={() => this.requestContract()}>
                        <RefreshIcon />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
                {(this.state.contractType === "outbound" ||
                  this.state.contractType === "view") &&
                  this.state.contractData.status === "Published" &&
                  this.state.contractData.parties.to.name === "All" && (
                    <>
                      <Tooltip title={t("VIEW_REQUESTS")}>
                        <IconButton onClick={() => this.viewRequestors()}>
                          <ViewIcon />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
              </Grid>
            </Grid>
          </div>
        </div>
        <main style={{ position: "relative", marginTop: "10px" }}>
          <Grid container spacing={2}>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <Grid container justify="center" spacing={2}>
                <Grid container spacing={3}>
                  {/* <Grid item xs={12}>
                                    <h3>{t('VIEW_CONTRACT')}: {this.state.contractData.title}</h3>
                                </Grid> */}
                  {/* <Grid item xs={1} ></Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <Paper className="tablePaper">
                      {this.state.contractData.title && (
                        <>
                          <h3 style={{ marginTop: 0 }}>
                            {t("CONTRACT_INFO")}
                            {this.props.userPerms.includes(
                              "CUMULATOR-CONTRACT_UPDATE",
                            ) &&
                              this.state.contractType === "outbound" &&
                              (this.state.contractData.status === "Published" ||
                                this.state.contractData.status === "Draft") && (
                                <>
                                  <Tooltip title={t("EDIT")}>
                                    <IconButton
                                      style={{ float: "right" }}
                                      onClick={() => this.editContract()}
                                    >
                                      <EditIcon />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}
                          </h3>
                          <TableContainer>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>{t("EFFECTIVE_DATE")}</TableCell>
                                  <TableCell>{t("EXPIRY_DATE")}</TableCell>
                                  {this.state.contractType !== "view" && (
                                    <>
                                      <TableCell>
                                        {t("PROVIDER_TYPE")}
                                      </TableCell>
                                      <TableCell>
                                        {t("PROVIDER_NAME")}
                                      </TableCell>
                                    </>
                                  )}
                                  <TableCell>{t("STATUS")}</TableCell>
                                  <TableCell>{t("DESCRIPTION")}</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableRow>
                                  <TableCell>
                                    {this.state.contractData.effectiveDate
                                      ? this.state.contractData.effectiveDate.split(
                                          " ",
                                        )[0]
                                      : ""}
                                  </TableCell>
                                  <TableCell>
                                    {this.state.contractData.expiryDate
                                      ? this.state.contractData.expiryDate.split(
                                          " ",
                                        )[0]
                                      : ""}
                                  </TableCell>
                                  {this.state.contractType !== "view" && (
                                    <>
                                      <TableCell>
                                        {this.state.contractType === "outbound"
                                          ? this.changeProviderType(
                                              this.state.contractData.parties.to
                                                .type,
                                            )
                                          : this.changeProviderType(
                                              this.state.contractData.parties
                                                .from.type,
                                            )}
                                      </TableCell>
                                      <TableCell>
                                        {this.state.contractType === "outbound"
                                          ? this.state.contractData.parties.to
                                              .name
                                          : this.state.contractData.parties.from
                                              .name}
                                      </TableCell>
                                    </>
                                  )}
                                  <TableCell>
                                    {this.state.contractData.status}
                                  </TableCell>
                                  <TableCell>
                                    {this.state.contractData.description}
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </>
                      )}
                    </Paper>
                    <Paper className="tablePaper" style={{ marginTop: "30px" }}>
                      {this.state.contractData.items && (
                        <>
                          <h3 style={{ marginTop: 0 }}>
                            {t("CONTRACT_DOCUMENTS")}
                            {this.props.userPerms.includes(
                              "CUMULATOR-CONTRACT_UPDATE",
                            ) &&
                              this.state.contractType === "outbound" &&
                              (this.state.contractData.status === "Published" ||
                                this.state.contractData.status === "Draft") && (
                                <Tooltip title="Upload">
                                  <IconButton
                                    style={{ float: "right" }}
                                    onClick={() => this.addDocument()}
                                  >
                                    <AddDocumentsIcon />
                                  </IconButton>
                                </Tooltip>
                              )}
                          </h3>
                          <TableContainer>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>{t("NAME")}</TableCell>
                                  <TableCell>{t("EFFECTIVE_DATE")}</TableCell>
                                  <TableCell>{t("STATUS")}</TableCell>
                                  <TableCell align="center">
                                    {t("DOWNLOAD")}
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.contractData.items.map(
                                  (item, i) => (
                                    <TableRow key={i}>
                                      <TableCell
                                        onClick={() => this.viewPdf(item.id)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        {item.document.name}
                                      </TableCell>
                                      <TableCell>
                                        {item.document.effectiveDate
                                          ? item.document.effectiveDate.split(
                                              " ",
                                            )[0]
                                          : ""}
                                      </TableCell>
                                      <TableCell>
                                        {item.document.status}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          paddingTop: "5px",
                                          paddingBottom: "5px",
                                        }}
                                        align="center"
                                      >
                                        <Tooltip
                                          title={t("DOWNLOAD_DOCUMENT")}
                                          style={{
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                          }}
                                        >
                                          <img
                                            src={pdfIcon}
                                            style={{
                                              width: "32px",
                                              cursor: "pointer",
                                            }}
                                            onClick={(e) =>
                                              this.downloadPdf(
                                                item.id,
                                                item.document.name,
                                              )
                                            }
                                          />
                                        </Tooltip>
                                        &nbsp;
                                        {this.props.userPerms.includes(
                                          "CUMULATOR-CONTRACT_UPDATE",
                                        ) &&
                                          this.state.contractType ===
                                            "outbound" &&
                                          (this.state.contractData.status ===
                                            "Published" ||
                                            this.state.contractData.status ===
                                              "Draft") && (
                                            <Tooltip
                                              title={t("DELETE_DOCUMENT")}
                                              style={{
                                                paddingTop: 0,
                                                paddingBottom: 0,
                                              }}
                                            >
                                              <IconButton
                                                onClick={() =>
                                                  this.deleteDoc(item.id)
                                                }
                                              >
                                                <DeleteIcon />
                                              </IconButton>
                                            </Tooltip>
                                          )}
                                      </TableCell>
                                    </TableRow>
                                  ),
                                )}
                                {this.state.contractData.items.length === 0 && (
                                  <TableRow>
                                    <TableCell colSpan={4} align="center">
                                      {t("NO_DOCUMENT_FOUND")}
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </>
                      )}
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* Add contract documents modal */}
          <UploadDocumentsDialog
            open={this.state.open}
            close={this.closeDocumentDialog}
            contractId={this.state.contractId}
            title={this.state.contractData.title}
            effectiveDate={this.state.contractData.effectiveDate}
            expiryDate={this.state.contractData.expiryDate}
            providerId={this.props.tenantId}
            providerType={this.props.providerType}
            selectedContractReceiver={this.state.selectedContractReceiver}
          />

          {/* edit contract data */}
          {this.state.openEditContract && (
            <EditContract
              open={this.state.openEditContract}
              close={this.closeUpdateContract}
              providerType={this.props.providerType}
              contractData={this.state.selectedContractToEdit}
              salesChannelProvidersList={this.state.salesChannelProvidersList}
              solutionProvidersList={this.state.solutionProvidersList}
              serviceProvidersList={this.state.serviceProvidersList}
            />
          )}

          {/* View contractors list dialog */}
          {this.state.showRequestorsDialog && (
            <ViewRequestorsDialog
              open={this.state.showRequestorsDialog}
              contractId={this.state.contractData.id}
              requestorListPartyId={this.state.requestorListPartyId}
              contractTitle={this.state.contractData.title}
              copyContract={this.state.copyContract}
              close={this.closeRequestorDialog}
            />
          )}

          {/* Delete document confirmation */}
          <Dialog
            disableScrollLock={true}
            open={this.state.openDeleteDialog}
            PaperComponent={this.draggableDialogPaper}
            maxWidth="sm"
            fullWidth={true}
          >
            <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {t("DELETE_DOCUMENT")}
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={() => this.closeDeleteConfirmation(false)}
                    onClick={() => this.closeDeleteConfirmation(false)}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <DialogContentText>
                {t("DELETE_DOCUMENT_CONFIRMATION")}
              </DialogContentText>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                onClick={(event) => this.closeDeleteConfirmation(false)}
                color="primary"
              >
                {t("NO")}
              </Button>
              <Button
                onClick={(event) => this.closeDeleteConfirmation(true)}
                color="primary"
              >
                {t("YES")}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Delete contract confirmation */}
          <Dialog
            disableScrollLock={true}
            open={this.state.openDeleteContractDialog}
            PaperComponent={this.draggableDialogPaper}
            maxWidth="sm"
            fullWidth={true}
          >
            <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {t("DELETE_CONTRACT")}
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={() =>
                      this.closeDeleteContractConfirmation(false)
                    }
                    onClick={() => this.closeDeleteContractConfirmation(false)}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <DialogContentText>
                {t("DELETE_CONTRACT_CONFIRMATION")}
              </DialogContentText>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                onClick={(event) => this.closeDeleteContractConfirmation(false)}
                color="primary"
              >
                {t("NO")}
              </Button>
              <Button
                onClick={(event) => this.closeDeleteContractConfirmation(true)}
                color="primary"
              >
                {t("YES")}
              </Button>
            </DialogActions>
          </Dialog>

          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    userPerms: state.auth.userPerms,
    providerType: state.auth.providerType,
    tenantId: state.auth.tenantId,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(ViewContract)));
